.progress-indicator-text {
  margin-bottom: $space-02;
  padding-top: $space-03;

  @include agl-ds-screen-size('medium') {
    margin-bottom: $space-01;
    padding-top: $space-04;
  }

  @include agl-ds-screen-size('large') {
    padding-top: $space-06;
  }
}
